import React, { useState, useEffect, useCallback } from 'react';
import { Table, Message } from '@b-design/fusion';
import { Divider } from '@alifd/next';
import $i18n from '@/i18n';
import Confirm from '@/components/Confirm';
// import Spining from '@/components/Spining';
import PaginationComponent from '@/components/PaginationComponent';
import { renderActionItem, columns } from './const.js';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';

interface Props {
  queryInvitations?: any;
  dataSource?: any;
  loading?: any;
  paginationValue?: any;
  setPaginationValue?: any;
  contentHeight: number;
}

const InvitationsRecord: React.FC<Props> = ({
  queryInvitations,
  dataSource,
  loading,
  paginationValue,
  setPaginationValue,
  contentHeight,
}) => {
  // const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const [column, setcolumns] = useState(columns);
  // filter
  const [filterValue, setFilterValue] = useState<{
    status?: string | undefined;
  }>();
  // const [loading, setLoading] = useState(false);
  // 分页参数
  // const [paginationValue, setPaginationValue] = useState<
  //   Record<'currentPage' | 'pageSize', number>
  // >({
  //   currentPage: 1,
  //   pageSize: 10,
  // });

  const { spaceId } = getQueryStringArgs();

  useEffect(() => {
    queryInvitations({ spaceId, ...paginationValue, type: 'SPACE_CREATE' });
  }, [paginationValue, queryInvitations, spaceId]);
  // 重新发送
  const resend = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/invitation/resend', {
        invitationCode: record.invitationCode,
        spaceId: record.spaceId,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.Success',
            dm: '操作成功',
          }),
        });
        queryInvitations({ spaceId, ...paginationValue, type: 'SPACE_CREATE' });
      }
    },
    [queryInvitations, paginationValue],
  );
  // 撤回
  const withdraw = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/invitation/revoke', {
        invitationCode: record.invitationCode,
        spaceId: record.spaceId,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.Success',
            dm: '操作成功',
          }),
        });
        queryInvitations({ spaceId, ...paginationValue, type: 'SPACE_CREATE' });
      }
    },
    [queryInvitations, paginationValue],
  );
  useEffect(() => {
    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 220,
      cell: (_v, _i, record) => (
        <div
          style={{
            color: 'var(--superapp-primary-1)',
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
          }}
        >
          {/* <div
            onClick={() => {
              startAcition?.[record?.status].includes('Resend') && onOk('resend', { invitationCode: record?.invitationCode })
            }}
          >
            {renderActionItem({
              icon: 'redo',
              i18nId: 'aopf.pages.member.Invitations.columnsActionResend',
              dm: '重新发送',
              abled: false,
            })}
          </div> */}
          {record?.status === 'INVITE' ? (
            <Confirm
              trigger={renderActionItem({
                icon: 'redo',
                content: $i18n.get({
                  id: 'aopf.pages.member.Invitations.columnsActionResend',
                  dm: '重新发送',
                }),
                // i18nId: 'aopf.pages.member.Invitations.columnsActionResend',
                // dm: '重新发送',
                active: true,
              })}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.invitations.columnsActionResend.messageTitle',
                dm: '重新发送',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.invitations.columnsActionResend.message',
                dm: '确定重新发送?',
              })}
              width={500}
              onClick={resend.bind(null,record)}
            />
          ) : (
            renderActionItem({
              icon: 'redo',
              content: $i18n.get({
                id: 'aopf.pages.invitations.columnsActionResend.messageTitle',
                dm: '重新发送',
              }),
              // i18nId: 'aopf.pages.invitations.columnsActionResend.messageTitle',
              // dm: '重新发送',
              active: false,
            })
          )}
          <Divider direction="ver" />

          {/* TODO */}
          {record?.status === 'INVITE' ? (
            <Confirm
              trigger={renderActionItem({
                icon: 'undo',
                content: $i18n.get({
                  id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                  dm: '撤退',
                }),
                // i18nId: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                // dm: '撤退',
                active: true,
              })}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.messageTitle',
                dm: '撤回',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw.message',
                dm: '确认撤回？',
              })}
              width={500}
              onClick={withdraw.bind(null, record)}
            />
          ) : (
            renderActionItem({
              icon: 'undo',
              content: $i18n.get({
                id: 'aopf.pages.member.Invitations.columnsActionWithdraw',
                dm: '撤退',
              }),
              // i18nId: 'aopf.pages.member.Invitations.columnsActionWithdraw',
              // dm: '撤退',
              active: false,
            })
          )}
        </div>
      ),
    };
    setcolumns([...columns, actionRender]);
  }, [paginationValue, spaceId, withdraw, resend]);
  return (
    <div>
      <div className="list-content">
        {/* {loading && <Spining />} */}
        <Table.StickyLock
          columns={column}
          fixedHeader
          maxBodyHeight={contentHeight - 48}
          loading={loading}
          dataSource={dataSource?.list}
          rowkey="name"
        />
        <div className="pagenation-container">
          <PaginationComponent
            total={dataSource?.total}
            current={paginationValue?.currentPage}
            pageSize={paginationValue?.pageSize}
            onPageChange={(current, pageSize) => {
              setPaginationValue({
                currentPage: current,
                pageSize,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default InvitationsRecord;
